export default {
  setBreadcrumbs(state, payload) {
    state.breadcrumbs = payload;
  }
};